import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { PIE_CHART_COLORS } from "../utils/utils";
import ChartToolTip from "../views/pages/dashboard/ChartTooltip";

// Function to calculate percentage labels
const renderCustomizedLabel = ({ name, value, percent }) => {
  return `${(percent * 100).toFixed(2)}%`;
};

const CustomLegend = ({ payload, legendWidth }) => {
  return (
    <div className="position-relative pie_legend_div">
      {payload.map((entry, index) => (
        <div key={`item-${index}`} className="legend_payload_div">
          <span
            style={{
              backgroundColor: entry.color,
            }}
            className="legend_payload_span"
          />
          <span
            className={`legend_payload_span_text ${
              legendWidth ? "legend_text_width" : ""
            } `}
          >
            {entry.value}
          </span>
        </div>
      ))}
    </div>
  );
};

const DataPieChart = ({ data, isDataForChart, legendWidth }) => (
  <>
    {!isDataForChart ? (
      <>
        <ResponsiveContainer width="100%" height={450}>
          <PieChart margin={{ top: 20 }}>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={Math.min(130, window.innerWidth * 0.12)} // Responsive radius
              fill="#8884d8"
              label={renderCustomizedLabel}
              legendType="square"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={PIE_CHART_COLORS[index]} />
              ))}
            </Pie>
            <Tooltip
              content={<ChartToolTip prefix="Percentage:" suffix="%" />}
            />
            <Legend content={<CustomLegend legendWidth={legendWidth} />} />
          </PieChart>
        </ResponsiveContainer>
      </>
    ) : (
      <div className="accreditation-msg">No Data Exists</div>
    )}
  </>
);

export default DataPieChart;
